import styled from 'styled-components';
export default styled.div`
h1 {
  font-size: 2.0rem;
  text-align: left;
  margin-bottom: 0.4em;
}
.badge-pill {
    padding-right: 0.9em;
    padding-left: 0.9em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    border-radius: 10rem;
    margin-right: 4px;
    margin-bottom: 4px;
}
.badge {
  font-size: 14px;
}
.badge-blue {
  color: #fff;
  background-color: #00a2dd;
}

.widget-area{
  padding:0;
}
.btn-box {
  text-align: center;
  margin-top: 50px;
}
@media screen and (min-width: 768px) and (max-width: 991px){
	.row .col-lg-6:first-child {
		order: 2;
	}
}
@media screen and (max-width: 767px) {
	.row .col-lg-6:first-child {
		order: 2;
	}
	.row .col-lg-6:first-child(2) {
		order: 1;
	}
} 
`;